<div class="admin-bar">Admin</div>
<app-menu></app-menu>
<app-login-validation (loggedIn)="onLoginValidated($event)"></app-login-validation>

<div class="page">
  <div class="container">
    <div class="header-row">
      <h1>Usuários</h1>
    </div>

    <!-- Indicadores -->
    <div class="cards" *ngIf="indicators">
      <div class="card">
        <div class="card-title">Cadastrados (últimos 30 dias)</div>
        <div class="card-value">{{ indicators.usersLast30Days }}</div>
      </div>
      <div class="card">
        <div class="card-title">Perfis de publicação (últimos 30 dias)</div>
        <div class="card-value">{{ indicators.publicationProfilesLast30Days }}</div>
      </div>
      <div class="card">
        <div class="card-title">Total de usuários</div>
        <div class="card-value">{{ indicators.totalUsers }}</div>
      </div>
    </div>

    <!-- Filtros -->
    <form class="filters" [formGroup]="form" (ngSubmit)="applyFilters()">
      <div class="filters-grid">
        <mat-form-field appearance="outline" class="field">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="name" placeholder="Pesquisar por nome..." />
        </mat-form-field>

        <mat-form-field appearance="outline" class="field">
          <mat-label>Email</mat-label>
          <input matInput formControlName="email" placeholder="Pesquisar por email..." />
        </mat-form-field>
      </div>

      <div class="ranges">
        <div class="range-col">
          <span class="range-label">Data de cadastro</span>
          <div class="range-row">
            <mat-form-field appearance="outline" class="field">
              <mat-label>De</mat-label>
              <input matInput [matDatepicker]="dpInclusionStart" formControlName="inclusionStart">
              <mat-datepicker-toggle matSuffix [for]="dpInclusionStart"></mat-datepicker-toggle>
              <mat-datepicker #dpInclusionStart></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="field">
              <mat-label>Até</mat-label>
              <input matInput [matDatepicker]="dpInclusionEnd" formControlName="inclusionEnd">
              <mat-datepicker-toggle matSuffix [for]="dpInclusionEnd"></mat-datepicker-toggle>
              <mat-datepicker #dpInclusionEnd></mat-datepicker>
            </mat-form-field>
          </div>
        </div>

        <div class="range-col">
          <span class="range-label">Perfil de publicação preenchido</span>
          <div class="range-row">
            <mat-form-field appearance="outline" class="field">
              <mat-label>De</mat-label>
              <input matInput [matDatepicker]="dpProfileStart" formControlName="profileStart">
              <mat-datepicker-toggle matSuffix [for]="dpProfileStart"></mat-datepicker-toggle>
              <mat-datepicker #dpProfileStart></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="field">
              <mat-label>Até</mat-label>
              <input matInput [matDatepicker]="dpProfileEnd" formControlName="profileEnd">
              <mat-datepicker-toggle matSuffix [for]="dpProfileEnd"></mat-datepicker-toggle>
              <mat-datepicker #dpProfileEnd></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="filters-toggles">
        <mat-slide-toggle formControlName="onlyBuyers">Apenas compradores de livro</mat-slide-toggle>
        <mat-slide-toggle formControlName="onlyPublishers">Apenas usuários que publicaram livros</mat-slide-toggle>
      </div>

      <div class="filters-actions">
        <button mat-raised-button class="btn-primary button-login" type="submit">Aplicar filtros</button>
        <button mat-stroked-button type="button" (click)="resetFilters()">Limpar</button>
        <button mat-stroked-button type="button" class="btn-export" [disabled]="isExporting" (click)="downloadCsv()"
                matTooltip="Exporta um CSV com todos os usuários dos filtros aplicados (sem paginação)">
          <ng-container *ngIf="isExporting; else exportTpl">
            <mat-spinner [diameter]="20" class="export-spinner"></mat-spinner>
          </ng-container>
          <ng-template #exportTpl>
            <mat-icon>download</mat-icon>
            Download dados
          </ng-template>
        </button>
      </div>
    </form>

    <ng-container *ngIf="isLoading; else listTpl">
      <div class="spinner">
        <mat-progress-spinner mode="indeterminate" diameter="56"></mat-progress-spinner>
      </div>
    </ng-container>

    <ng-template #listTpl>
      <!-- Cabeçalho -->
      <div class="list-header">
        <div class="col name">Nome</div>
        <div class="col phone">Telefone</div>
        <div class="col email">Email</div>
        <div class="col date">Cadastro</div>
        <div class="col type">Tipo de livro</div>
        <div class="col ready">Texto pronto</div>
        <div class="col timeframe">Prazo</div>
        <div class="col budget">Orçamento</div>
        <div class="col profile-date">Perfil em</div>
        <div class="col actions">Ações</div>
      </div>

      <!-- Linhas -->
      <div class="row" *ngFor="let u of list; trackBy: trackByUser">
        <div class="col name">
          <div class="title-text">{{ u.userName || '—' }}</div>
        </div>
        <div class="col phone">{{ u.mobilePhone || '—' }}</div>
        <div class="col email">{{ u.userEmail || '—' }}</div>
        <div class="col date">{{ u.datetimeInclusion | date:'dd/MM/yyyy HH:mm' }}</div>
        <div class="col type">{{ bookTypeLabel(u.publicationBookType) }}</div>
        <div class="col ready">{{ textReadyLabel(u.publicationTextReady) }}</div>
        <div class="col timeframe">{{ timeframeLabel(u.publicationTimeframe) }}</div>
        <div class="col budget" [matTooltip]="budgetLabel(u.publicationBudget)">{{ budgetLabel(u.publicationBudget) }}</div>
        <div class="col profile-date">{{ u.datetimePublicationProfile ? (u.datetimePublicationProfile | date:'dd/MM/yyyy HH:mm') : '—' }}</div>
        <div class="col actions">
          <button mat-icon-button
                  matTooltip="Ver detalhes"
                  aria-label="Ver detalhes"
                  (click)="openDetails(u.idUser)">
            <mat-icon style="color:#0c720c;">visibility</mat-icon>
          </button>
        </div>
      </div>

      <div *ngIf="!list?.length" class="empty">
        Nenhum usuário encontrado.
      </div>

      <!-- Ver mais -->
      <div class="load-more" *ngIf="list?.length">
        <span class="load-more-info">{{ list.length }} de {{ total }} usuários</span>
        <button mat-stroked-button *ngIf="hasMore" [disabled]="isLoadingMore" (click)="loadMore()">
          <ng-container *ngIf="isLoadingMore; else verMaisTpl">
            <mat-spinner [diameter]="20" class="load-more-spinner"></mat-spinner>
          </ng-container>
          <ng-template #verMaisTpl>Ver mais</ng-template>
        </button>
      </div>
    </ng-template>
  </div>
</div>

<app-footer></app-footer>
